import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IconButton, Grid, Card, Tooltip } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import { DeleteIcon } from "@icarius-icons";
import { deleteUserMenusAction } from "../../actions";
import DataContainer from "@icarius-common/abmComponents/dataContainer";
import { openDialogAction } from "@icarius-common/dialog/actions";
import { getAppColor } from "@icarius-app/selectors";
import { roleNames } from "@icarius-utils/constants";
import Form from "./form";

const DataItem = (props) => {
    const { data, trees, closeNew } = props;

    const dispatch = useDispatch();
    const color = useSelector(getAppColor);
    const isCreate = !Boolean(data);

    const [isOpen, setIsOpen] = useState(isCreate); //si viene sin data, que este abierto por defecto

    const handleDeletePublication = () => {
        if (isCreate) {
            closeNew();
        } else {
            dispatch(deleteUserMenusAction({ functionCode: data.functionCode }));
        }
    };

    const handleClosePublication = () => {
        Boolean(data) && setIsOpen((prev) => !prev);
    };

    // En la card de alta este boton no borra nada: handleDeletePublication cae en
    // closeNew() y descarta lo tipeado sin crear. El dialogo igual decia "borrar",
    // que es enganoso, asi que en alta se confirma como cancelacion.
    const handleOpenDeleteDialog = () => {
        dispatch(
            openDialogAction({
                title: isCreate ? getLocalizedString("cancel") : getLocalizedString("deleteUserMenu"),
                msg: isCreate
                    ? getLocalizedString("unsavedChangesConfirmation")
                    : getLocalizedString("wantToDeleteUserMenu"),
                onConfirm: handleDeletePublication,
            })
        );
    };

    return (
        <>
            <Card
                style={{
                    width: "100%",
                    borderRadius: 10,
                    background: isOpen || isCreate ? color : "",
                    color: (isOpen || isCreate) && "white",
                }}
            >
                <Grid container item xs={12} direction="row" style={{ padding: "10px 20px" }}>
                    <Grid
                        container
                        item
                        xs={11}
                        style={{ cursor: Boolean(data) ? "pointer" : "" }}
                        onClick={handleClosePublication}
                    >
                        {isCreate ? (
                            <DataContainer lg={12} sm={12} md={12} text={getLocalizedString("userMenuCreation")} />
                        ) : (
                            <>
                                <DataContainer sm={12} lg={2} md={2} text={data.functionCode} />
                                <DataContainer sm={12} lg={4} md={4} text={data.functionName} />
                                <DataContainer sm={12} lg={4} md={4} text={data.name} />
                                <DataContainer sm={12} lg={2} md={2} text={getLocalizedString(roleNames[data.role])} />
                            </>
                        )}
                    </Grid>

                    <Grid container direction="row" item xs={1} justify="center">
                        <Tooltip title={getLocalizedString("delete")}>
                            <IconButton size={"small"} disableRipple onClick={handleOpenDeleteDialog}>
                                <DeleteIcon style={{ fill: "var(--mainText)" }} fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Card>
            {isOpen && <Form data={data} trees={trees} handleClose={isCreate ? closeNew : handleClosePublication} />}
        </>
    );
};

export default DataItem;
